import {RouteConfig} from 'vue-router';

export const beniRoutes: RouteConfig = {
    path: 'beni',
    component: () => import('@/views/private/beni/BeniView.vue'),
    children: [
        {
            path: '',
            name: 'beni',
            component: () => import('@/views/private/beni/index/BeniIndex.vue'),
        },
        {
            path: 'create',
            name: 'beni/create',
            component: () => import('@/views/private/beni/create/BeniCreate.vue'),
            meta: {
                breadcrumbs: [
                    {
                        text: 'Beni', to: {name: 'beni'}, color: '#E0E0E0',
                    },
                    {
                        text: 'Inserimento Bene', color: '#2c3e50',
                    },
                ],
            }
        },
        {
            path: 'edit/:id',
            name: 'beni/edit',
            component: () => import('@/views/private/beni/edit/BeniEdit.vue'),
            meta: {
                breadcrumbs: [
                    {
                        text: 'Beni', to: {name: 'beni'}, color: '#E0E0E0',
                    },
                    {
                        text: 'Modifica Bene', color: '#2c3e50',
                    },
                ],
            },
            children: [
                {
                    path: 'vincoli/create',
                    name: 'beni/vincoli/create',
                    component: () => import('@/views/private/beni/edit/VincoloCreate.vue'),
                },
                {
                    path: 'vincoli/edit/:vincoloId',
                    name: 'beni/vincoli/edit',
                    component: () => import('@/views/private/beni/edit/VincoloUpdate.vue'),
                },
                {
                    path: 'geometrie/:vincoloId',
                    name: 'beni/geometrie',
                    component: () => import('@/views/private/beni/geometrie/GeometrieIndex.vue'),
                }
            ]
        },

    ],
};
